import moment from 'moment-wrapper';
import calculatePeriodFromRangeKey from 'utils/dateRange/calculatePeriodFromRangeKey';

function formatCustomPeriod (customPeriod, calcDeltaPeriod = false, calculateFutureDays = false) {
  let period = {};

  let dateStart = moment(customPeriod.startDate);
  let dateEnd = moment(customPeriod.endDate);

  if (calcDeltaPeriod) {
    // if it's the end of the period
    if (moment().formatDateApi() === moment(customPeriod.endDate).formatDateApi()) {
      dateStart = moment(customPeriod.endDate);
      if (customPeriod.deltaStartDate || customPeriod.deltaStartDate === 0) {
        const periodDuration = Math.abs(customPeriod.deltaStartDate) + Math.abs(customPeriod.deltaEndDate);
        dateEnd = moment(dateStart).add(periodDuration, 'days');
      } else if (customPeriod.periodDuration || customPeriod.periodDuration === 0) {
        dateEnd = moment().add(customPeriod.periodDuration, 'days');
      }
    }
  } else if (customPeriod.rangeKey) {
    let calculatedPeriod = calculatePeriodFromRangeKey(customPeriod.rangeKey, calculateFutureDays);

    dateStart = moment(calculatedPeriod.startDate);
    dateEnd = moment(calculatedPeriod.endDate);
  }

  period.dateStart = dateStart.format('YYYY-MM-DD');
  period.dateEnd = dateEnd.format('YYYY-MM-DD');
  period.totalDays = moment(dateEnd).diff(moment(dateStart), 'days') + 1;

  return period;
}

export default formatCustomPeriod;
